"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.period.lastWeek': 'Last Week',
    'reports.period.lastMonth': 'Last Month',
    'reports.period.last3Months': 'Last 3 Months',
    'reports.period.lastYear': 'Last Year',
    'reports.period.allTime': 'All Time',
    'reports.period.custom': 'Custom Range',
};
